module.exports = __webpack_public_path__ + "dd091dc7ee97e76f1147a35f4d856abe.png";